// Core
import React, { useState, useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';

// Components
import RewardsClub from '../Home/components/RewardsClub';
import Success from 'components/Form/Success';

const Download = () => {
  const [deviceType, setDeviceType] = useState('');
  const [notify, setNotify] = useState();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const successParam = params.get('set-password');
    if (successParam) {
      setNotify(successParam);
    }
  }, []);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/android/i.test(userAgent)) {
      setDeviceType('Android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setDeviceType('iOS');
    } else {
      setDeviceType('Other');
    }
  }, []);

  return (
    <Box pb="80px">
      { notify && 
        <Box pt={{base: '40px', md: '80px'}} mb={{base: '-20px'}}>
          <Success success="Registration successful! You can now sign in." setNotify={setNotify} /><
        /Box>
      }

      <Text id="download" as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt="0px" pt={{base: '60px', md: '80px'}} mb={{base: '24px', sm: '32px'}}>Download the App</Text>
      <RewardsClub deviceType={deviceType} />
    </Box>
  );
};

export default Download;